import { render, staticRenderFns } from "./SystemModuleView.vue?vue&type=template&id=451e7154&scoped=true"
import script from "./SystemModuleView.vue?vue&type=script&lang=js"
export * from "./SystemModuleView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451e7154",
  null
  
)

export default component.exports